<p-inputGroup  *ngIf="!searchable">


    <p-chips
        id="personnelChips"
        [(ngModel)]="pickerChipData"
        [ngModelOptions]="{ standalone: true }"
        [max]="8"
        [allowDuplicate]="false"
        [disabled]="disabled"
        (onRemove)="onRemove($event)"
        class="hvl-entity-picker-chips"
        styleClass="hvl-entity-picker-chips-override"
        field="fullName"
    >
        <ng-template let-item pTemplate="item">
            {{showSelectedPerCount === false && selectionMode != 'multiple' ? item.fullName : getPerCountText()}}
        </ng-template>

    </p-chips>


    <button (click)="onShow()" *ngIf="!disabled" [disabled]="disabled" id="personnelPickerButton" label=" "
            class="btn-icon-only hvl-entity-picker-search-button" pButton type="button">
        <i aria-hidden="true" class="material-icons">search</i>
    </button>
</p-inputGroup>
<div class="p-inputgroup" *ngIf="searchable">
    <hr-per-personnel-search
        [selectedItem]="selectedPersonnel"
        #hrPerPersonnelSearch
        [isPictureVisible]="false"
        [minSearchLength]="3"
        placeHolder="{{ 'autocompleteSearchText' | translate }}"
        [showEmptyMessage]="true"
        [emptyMessage]="'noRecordsFound' | translate"
        (valueEvent)="onSearchPersonnelSelect($event)"
        [queryModel]="searchQueryModel"
        class="w-full"
        [showClear]="true"
    ></hr-per-personnel-search>
    <button (click)="onShow()" [disabled]="false" id="personnelPickerButtonSearch" label=" "
            class="" icon="pi pi-search" pButton type="button">
    </button>
</div>
